import Http from '@services/httpClient';

const prefix = '/api/v1';

export default {
  async pushEvent(page: string, action = 'pageview') {
    return Http.post({
      url: `${prefix}/event-tracker`,
      data: {
        page,
        action,
      },
    })
      .then((val) => val.data)
      .catch((e) => {
        throw e;
      });
  },
};
